// vendor import
import { SnifferProvider } from './sniffer';
import { ClipboardProvider } from './clipboard';
import { DexieProvider } from './dexie';

export const vendor: any[] = [
  // vendor export
  SnifferProvider,
  ClipboardProvider,
  DexieProvider,
];
